if (typeof StorefrontApi === "undefined") {
  class StorefrontApi {
    static async request({ query, variables }) {
      try {
        const res = await fetch(
          `https://${window.Shopify.shop}/api/2025-10/graphql.json`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Shopify-Storefront-Access-Token":
                window.__STOREFRONT_API_TOKEN__,
            },
            body: JSON.stringify({
              query,
              variables,
            }),
          },
        );
        const json = await res.json();
        return json.data;
      } catch (err) {
        console.error("StorefrontApi request failed:", err);
      }
    }
  }
  window.StorefrontApi = StorefrontApi;
}
